import React, { Component } from "react"
import { Input, Button, Affix, Switch, Select, message } from "antd"
import { observer, inject } from "mobx-react"
import { action, observable } from "mobx"
import closeIcon from "app/styles/images/sp/close.svg"
import styled from 'styled-components'
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

const InputGroup = Input.Group
const Option = Select.Option

const CreateBaselineBtn = styled.button`
  width: 127px;
  height: 40px;
  background: #286CAC;
  color: white;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  border: none;
`

const SwitchWrap = styled(Switch)`
  &.ant-switch {
    position: absolute;
    left: 0;
  }
  &.ant-switch-checked{
    border-color: #286cac;
    background-color: #286cac;
  }
`
const MaterialFormItemWrap = styled(MaterialFormItem)`
  .ant-form-item-control {
    width: 280px;
  }
`

@inject("auth", "store") @observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
    }
  }
  componentDidMount() {
    this.props.auth.getChannelApps()
  }

  @action
  changeSearch = (e) => {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    const {
      list: { filterData }
    } = this.props.store
    const keywords = e.target.value

    this.timer = setTimeout(() => {
      this.timer = null
      this.setState({
        inputSearch: keywords,
      })
      filterData({ baselineParam: keywords })
    }, 300)
  }

  showBaselineModal = () => {
    this.setState({
      createModalShowed: true
    })
  }

  render() {
    const { createModalShowed } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="statistics-search-bar">
            <div className="search-input">
              <InputGroup className="ant-search-input">
                <Input
                  placeholder="输入基线参数搜索"
                  size="default"
                  onChange={this.changeSearch}
                />
                <div className="ant-input-group-wrap">
                  <Button icon="search" className="ant-search-btn" size="default" />
                </div>
              </InputGroup>
            </div>
            <CreateBaselineBtn
              className="create-account-btn"
              onClick={() => this.showBaselineModal()}
            >
              + 创建基线
            </CreateBaselineBtn>
            {createModalShowed && (
              <CreateBaselineModal
                store={this.props.store}
                onClose={() => this.setState({ createModalShowed: false })}
              />
            )}
          </div>
        </div>
      </Affix>
    )
  }
}

@inject("auth", "store") @observer
class CreateBaselineModal extends Component {
  @observable submitData = {
    orgId: "",
    userId: "",
    appId: "",
    baselineName: "",
    baselineParam: "",
    defaultBaseline: true
  }
  componentDidMount() {
    const { getUserList, getOrgList } = this.props.store
    getUserList()
    getOrgList()
  }

  setSubmitData = (field, value) => {
    this.submitData[field] = value
    this.observeDataChange(field)
  }

  isEmpty = (string) => {
    return (string === "" || typeof string === 'undefined' || string === null) ? true : false
  }

  observeDataChange = (field) => {
    const { orgId, userId } = this.submitData
    if ((field === "orgId" || field === 'userId') && (!this.isEmpty(orgId) && !this.isEmpty(userId))) {
      this.setSubmitData("baselineParam", orgId + '-' + userId)
    }
  }

  submit = () => {
    const { onClose } = this.props
    const { submitData: { orgId, userId, appId } } = this
    const { list, createBaseline } = this.props.store

    if (this.isEmpty(orgId)) return message.error("请选择机构")
    if (this.isEmpty(userId)) return message.error("请选择用户")
    if (this.isEmpty(appId)) return message.error("请选择应用")

    createBaseline(this.submitData)
      .then(res => {
        message.success("基线创建成功")
        list.getTableData()
          .then(res => {
            onClose()
            list.updateTableData(res)
            list.initPageIndex()
          }, err => {
            message.error(err)
            return Promise.reject(err)
          })
      }, err => {
        message.error(err)
        return Promise.reject(err)
      })
  }

  render() {
    const { onClose } = this.props
    const { channelApps } = this.props.auth
    const { orgList, userList } = this.props.store
    return (
      <MaterialModal
        title="创建基线"
        width={450}
        className="preview-account-create-modal"
        buttonText="确认添加"
        visible
        action={() => this.submit()}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <MaterialForm>
          <MaterialFormItem
            labelText="机构"
            labelWidth={70}
          >
            <Select
              showSearch
              placeholder="请选择所属机构"
              value={this.submitData.orgId === "" ? undefined : this.submitData.orgId}
              className="createAccount-input"
              onChange={(e) => this.setSubmitData("orgId", e)}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {orgList.slice().map(org => <Option key={org.id}>{org.name}</Option>)}
            </Select>
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={70}
            labelText="用户"
          >
            <Select
              showSearch
              value={this.submitData.userId === "" ? undefined : this.submitData.userId}
              placeholder="请选择用户"
              className="createAccount-input"
              onChange={(e) => this.setSubmitData("userId", e)}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {userList.slice().map(user => <Option key={user.id}>{user.username}</Option>)}
            </Select>
          </MaterialFormItem>
          <MaterialFormItem
            labelText="应用"
            labelWidth={70}
          >
            <Select
              showSearch
              value={this.submitData.appId === "" ? undefined : this.submitData.appId}
              placeholder="请选择应用"
              className="createAccount-input"
              onChange={(e) => this.setSubmitData("appId", e)}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {channelApps.slice().map(app => <Option key={app.id}>{app.name}</Option>)}
            </Select>
          </MaterialFormItem>
          <MaterialFormItem
            labelText="基线名称"
            labelWidth={70}
          >
            <Input
              className="createAccount-input"
              placeholder="请输入基线名称"
              value={this.submitData.baselineName}
              onChange={(e) => this.setSubmitData("baselineName", e.target.value)}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelText="基线参数"
            labelWidth={70}
          >
            <Input
              className="createAccount-input"
              placeholder="请输入基线参数"
              value={this.submitData.baselineParam}
              onChange={(e) => this.setSubmitData("baselineParam", e.target.value)}
            />
          </MaterialFormItem>
          <MaterialFormItemWrap
            labelText="是否默认基线"
            labelWidth={70}
          >
            <SwitchWrap
              checked={this.submitData.defaultBaseline}
              checkedChildren="是"
              unCheckedChildren="否"
              onChange={(e) => this.setSubmitData("defaultBaseline", e)}
            />
          </MaterialFormItemWrap>
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/baseline/containers/DataHeader.js